// Enforce length AFTER normalization. A native maxlength would discard valid
// trailing digits when autofill/IME/paste supplies leading whitespace.
export const companyCodeInput = (value) => String(value || '').replace(/\s/g, '').toUpperCase().slice(0, 6);

export function authErrorMessage(error, fallback = 'Unable to continue. Please try again.') {
  const detail = error?.response?.data?.detail;
  if (typeof detail === 'string' && detail.trim()) return detail;
  if (Array.isArray(detail)) {
    const messages = detail.map(item => typeof item?.msg === 'string' ? item.msg : '').filter(Boolean);
    if (messages.length) return messages.join(' ');
  }
  if (typeof detail?.msg === 'string') return detail.msg;
  if (error?.response?.status === 429) return 'Too many attempts. Please wait before trying again.';
  if (error?.response?.status >= 500) return 'Service temporarily unavailable. Please try again shortly.';
  if (error?.request && !error?.response) return 'Unable to reach the server. Please try again.';
  return fallback;
}